import React, { HTMLAttributes, useEffect, useRef, useState } from "react";
import SectionTitle from "../../atoms/sectionTitle";

interface IVideoTutorialSection {}

type TVideoTutorialSectionProps = IVideoTutorialSection &
  HTMLAttributes<HTMLDivElement>;

const VideoTutorialSection: React.FC<TVideoTutorialSectionProps> = (props) => {
  const { ...otherProps } = props;
  const [srcUrl, setSrcUrl] = useState<string | null>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          // lazy-set src once when visible
          setSrcUrl(
            (prev) =>
              prev ?? `https://dqyerp2t68wdu.cloudfront.net/video_tutor.mp4`
          );
          setTimeout(() => videoRef.current?.play().catch(() => {}), 100);
        } else {
          // console.log("should pause video");
          videoRef.current?.pause(); // Pause the video when not visible
        }
      },
      { threshold: 0.5 } // Trigger when 50% of the section is visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={sectionRef}
      className="justify-center items-center flex flex-col p-5 laptop:py-10 laptop:px-[10%]"
      {...otherProps}
    >
      <SectionTitle chineseTitle="影片教學" englishTitle="Video tutorial" />

      <video
        ref={videoRef}
        controls
        className="aspect-video max-w-[640px] w-full"
        muted // Ensure the video is muted
        loop
        playsInline
        preload="metadata"
        src={srcUrl || undefined}
      ></video>
    </div>
  );
};

export default VideoTutorialSection;
